import qs from "qs";
import { lazy, useLayoutEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router";
import { actions as authActions, isAuthenticatedSelector, userSelector } from "store/auth";
import { isOpenedInIframe } from "utils/helpers";

const PublicPatientIntakePage = lazy(() => import("views/pages/PublicPatientIntake"));

const PublicPatientIntakePublicRouteGate = ({ pageTitle }) => {
	const dispatch = useDispatch();
	const { search } = useLocation();
	const { redirect_to = "/" } = qs.parse(search, { ignoreQueryPrefix: true });
	const isAuthenticated = useSelector(isAuthenticatedSelector);
	const user = useSelector(userSelector);
	const isDemoTenant = Boolean(user?.tenant?.is_demo);
	const inIframe = isOpenedInIframe();
	const didLogoutForIframe = useRef(false);

	useLayoutEffect(() => {
		if (!isAuthenticated) {
			didLogoutForIframe.current = false;
			return;
		}
		if (inIframe && !isDemoTenant && !didLogoutForIframe.current) {
			didLogoutForIframe.current = true;
			dispatch(authActions.logout());
		}
	}, [dispatch, inIframe, isAuthenticated, isDemoTenant]);

	if (inIframe && isAuthenticated && !isDemoTenant) return null;
	if (!isAuthenticated && !isDemoTenant) {
		return <PublicPatientIntakePage pageTitle={pageTitle} />;
	}
	return <Navigate to={redirect_to} replace />;
};

export default PublicPatientIntakePublicRouteGate;
